import Vue from 'vue'
import { Icon, Table, Avatar, Message } from "view-design";
import { getPartsAllService, inventoryDataColumns } from "@/service/device-info-service";
Vue.component('Icon', Icon);
Vue.component('Table', Table);
Vue.component('Avatar', Avatar);
/**
 * 统计模版
 * @type {{ List }}
 */
const Solution = {
    name:'Solution',
    props:{
        /**
         * 设备id
         */
        equipmentId:{
            type:Number,
        },
        /**
         * 备件id
         */
        sparePartsId:{
            type:Number,
        },
    },
    data() {
        return {
            inventoryDataColumns:inventoryDataColumns, //统计显示字段
            loading:false,
            inventoryData:[],
            lookPartsVisible:false,
            lookPartsArray:{},
        }
    },
    created() {
        this.onPartsListService().then()
    },
    methods:{
        rowClassName(row){
            if(row.status === 1){
                return 'table-row-grey'
            }
        },
        /**
         * 查看出入库
         * @param item
         */
        onLookRecord(item){
            this.lookPartsArray = item
            if(item.describes === ''){
                this.lookPartsArray.describes = '无'
            }
            this.lookPartsVisible = true
        },
        /**
         * 统计列表数据查询
         */
        async onPartsListService() {
            try {
                this.loading = true
                let params = {
                    equipmentId:this.equipmentId,
                    sparePartsId:this.sparePartsId,
                }
                const { code,data } = await getPartsAllService(params)
                if(code === 'SUCCESS'){
                    this.inventoryData = data
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.loading = false
            }catch (error){
                this.loading = false
                console.log(error)
            }
        },
    },
}
export default Solution
